<template>
	<div class="bbade387">
		<div class="ff5121c6">
			<div class="c99e7c5b">
				<img src="@/assets/pcLogo.png">
			</div>
			<div class="a3a6ac44">
				<div class="d5b4d024">下载 顶搜 App</div>
				<div class="a53644c6">AI 智能对话助手</div>
			</div>
		</div>
		<div class="c315dc57">
			<div class="d0ac95bb">Apple iOS</div>
			<div class="cd8aaf0e downBtn">
				<a href="https://apps.apple.com/cn/app/%E9%A1%B6%E6%90%9Cai/id6745086332">
					iOS下载
				</a>
			</div>
			<div class="d0ac95bb">Android</div>
			<div class="cd8aaf0e downBtn">
				<a href="https://ai.iptzx.com/dingso.apk">
					Android下载
				</a>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		data() {
			return{
				Android:'https://ai.iptzx.com/dingso.apk',
				iOS:'https://apps.apple.com/cn/app/%E9%A1%B6%E6%90%9Cai/id6745086332'
			}
		}
	}
</script>

<style>
	@import url('../../style/download.css');
	.c99e7c5b img
	{
		width: 100%;
	}
	.downBtn
	{
		display: block !important;
	}
	.downBtn a
	{
		display: block;
	}
</style>